/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccountId,
  ArrayCrmCommandRequestsDetailedDto,
  CommandAcceptedResponseDto,
  CommandIdDto,
  CrmActionExecutionHubspotDto,
  CrmActionExecutionSalesforceDto,
  CrmCommandRequestsDto,
  CrmGuestStateHubspotDto,
  CrmGuestStateSalesforceDto,
  EventIdOrHubspotEngagementId,
  MapEventIdOrHubspotEngagementIdMeetingId,
  MapString,
  MeetingRelationRequestHubspotDto,
  MeetingRelationRequestSalesforceDto,
  MeetingRelationResponseHubspotDto,
  MeetingRelationResponseSalesforceDto,
  OptionCommandIdDto,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "meetings-crm";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Find meetings by salesforce event or hubspot engagement ids
   *
   * @tags Meetings CRM Public API
   * @name GetApiV1PublicTenantTenantidEventMeetings
   * @request GET:/v1/public/tenant/{tenantId}/event-meetings
   */
  getApiV1PublicTenantTenantidEventMeetings = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      eventId?: EventIdOrHubspotEngagementId[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapEventIdOrHubspotEngagementIdMeetingId,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/event-meetings`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1PublicTenantTenantidEventMeetings */
  getApiV1PublicTenantTenantidEventMeetingsPathGetter = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      eventId?: EventIdOrHubspotEngagementId[];
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/event-meetings`, query);

  /**
   * @description Find crm id by email
   *
   * @tags Meetings CRM SecuredAPI
   * @name GetApiV1TenantTenantidWorkspaceWorkspaceidGuestMatchSalesforce
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/guest-match/salesforce
   * @secure
   */
  getApiV1TenantTenantidWorkspaceWorkspaceidGuestMatchSalesforce = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @pattern .+@.+ */
      email: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      CrmGuestStateSalesforceDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/guest-match/salesforce`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspaceWorkspaceidGuestMatchSalesforce */
  getApiV1TenantTenantidWorkspaceWorkspaceidGuestMatchSalesforcePathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @pattern .+@.+ */
      email: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/guest-match/salesforce`, query);

  /**
   * @description Find crm id by email
   *
   * @tags Meetings CRM SecuredAPI
   * @name GetApiV1TenantTenantidWorkspaceWorkspaceidGuestMatchHubspot
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/guest-match/hubspot
   * @secure
   */
  getApiV1TenantTenantidWorkspaceWorkspaceidGuestMatchHubspot = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @pattern .+@.+ */
      email: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      CrmGuestStateHubspotDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/guest-match/hubspot`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspaceWorkspaceidGuestMatchHubspot */
  getApiV1TenantTenantidWorkspaceWorkspaceidGuestMatchHubspotPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @pattern .+@.+ */
      email: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/guest-match/hubspot`, query);

  /**
   * @description Find what would crm event be related to if created
   *
   * @tags Meetings CRM SecuredAPI
   * @name PutApiV1TenantTenantidWorkspaceWorkspaceidMeetingRelationSalesforce
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/meeting/relation/salesforce
   * @secure
   */
  putApiV1TenantTenantidWorkspaceWorkspaceidMeetingRelationSalesforce = (
    tenantId: string,
    workspaceId: string,
    data: MeetingRelationRequestSalesforceDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingRelationResponseSalesforceDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting/relation/salesforce`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidWorkspaceWorkspaceidMeetingRelationSalesforce */
  putApiV1TenantTenantidWorkspaceWorkspaceidMeetingRelationSalesforcePathGetter = (
    tenantId: string,
    workspaceId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting/relation/salesforce`);

  /**
   * @description Find what would crm event be related to if created
   *
   * @tags Meetings CRM SecuredAPI
   * @name PutApiV1TenantTenantidWorkspaceWorkspaceidMeetingRelationHubspot
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/meeting/relation/hubspot
   * @secure
   */
  putApiV1TenantTenantidWorkspaceWorkspaceidMeetingRelationHubspot = (
    tenantId: string,
    workspaceId: string,
    data: MeetingRelationRequestHubspotDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingRelationResponseHubspotDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting/relation/hubspot`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidWorkspaceWorkspaceidMeetingRelationHubspot */
  putApiV1TenantTenantidWorkspaceWorkspaceidMeetingRelationHubspotPathGetter = (
    tenantId: string,
    workspaceId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting/relation/hubspot`);

  /**
   * No description
   *
   * @tags Meetings CRM SecuredAPI
   * @name PostApiV1TenantTenantidWorkspaceWorkspaceidExecuteCrmActionSalesforce
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/execute-crm-action/salesforce
   * @secure
   */
  postApiV1TenantTenantidWorkspaceWorkspaceidExecuteCrmActionSalesforce = (
    tenantId: string,
    workspaceId: string,
    data: CrmActionExecutionSalesforceDto,
    params: RequestParams = {},
  ) =>
    this.request<
      CommandAcceptedResponseDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/execute-crm-action/salesforce`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspaceWorkspaceidExecuteCrmActionSalesforce */
  postApiV1TenantTenantidWorkspaceWorkspaceidExecuteCrmActionSalesforcePathGetter = (
    tenantId: string,
    workspaceId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/execute-crm-action/salesforce`);

  /**
   * No description
   *
   * @tags Meetings CRM SecuredAPI
   * @name PostApiV1TenantTenantidWorkspaceWorkspaceidExecuteCrmActionHubspot
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/execute-crm-action/hubspot
   * @secure
   */
  postApiV1TenantTenantidWorkspaceWorkspaceidExecuteCrmActionHubspot = (
    tenantId: string,
    workspaceId: string,
    data: CrmActionExecutionHubspotDto,
    params: RequestParams = {},
  ) =>
    this.request<
      CommandAcceptedResponseDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/execute-crm-action/hubspot`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspaceWorkspaceidExecuteCrmActionHubspot */
  postApiV1TenantTenantidWorkspaceWorkspaceidExecuteCrmActionHubspotPathGetter = (
    tenantId: string,
    workspaceId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/execute-crm-action/hubspot`);

  /**
   * @description Find requests by command id
   *
   * @tags Meetings CRM SecuredAPI
   * @name GetApiV1TenantTenantidCrmRequests
   * @request GET:/v1/tenant/{tenantId}/crm-requests
   * @secure
   */
  getApiV1TenantTenantidCrmRequests = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      commandId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      CrmCommandRequestsDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/crm-requests`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidCrmRequests */
  getApiV1TenantTenantidCrmRequestsPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      commandId: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/crm-requests`, query);

  /**
   * @description Find detailed requests by command ID or source ID. Set includeRetried=true to include retry-triggered requests. EXPERIMENTAL: This API is not stable and may change without notice
   *
   * @tags Experimental, Meetings CRM SecuredAPI
   * @name GetApiV1TenantTenantidCrmRequestsDetailed
   * @request GET:/v1/tenant/{tenantId}/crm-requests-detailed
   * @secure
   */
  getApiV1TenantTenantidCrmRequestsDetailed = (
    tenantId: string,
    query?: {
      /** @pattern [^\s\\/]+ */
      commandId?: string;
      /** @pattern [^\s\\/]+ */
      requestSourceId?: string;
      /** @default false */
      includeRetried?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayCrmCommandRequestsDetailedDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/crm-requests-detailed`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidCrmRequestsDetailed */
  getApiV1TenantTenantidCrmRequestsDetailedPathGetter = (
    tenantId: string,
    query?: {
      /** @pattern [^\s\\/]+ */
      commandId?: string;
      /** @pattern [^\s\\/]+ */
      requestSourceId?: string;
      /** @default false */
      includeRetried?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/crm-requests-detailed`, query);

  /**
   * @description Retry a command. CommandId in path is a retry target, commandId in query new commandId
   *
   * @tags Meetings CRM SecuredAPI
   * @name PostApiV1TenantTenantidCommandCommandidRetry
   * @request POST:/v1/tenant/{tenantId}/command/{commandId}/retry
   * @secure
   */
  postApiV1TenantTenantidCommandCommandidRetry = (
    tenantId: string,
    commandId: string,
    query?: {
      /** @default false */
      retryNonFailed?: boolean;
      /** @pattern [^\s\\/]+ */
      crmRequestId?: string;
    },
    data?: OptionCommandIdDto,
    params: RequestParams = {},
  ) =>
    this.request<
      CommandAcceptedResponseDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/command/${commandId}/retry`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidCommandCommandidRetry */
  postApiV1TenantTenantidCommandCommandidRetryPathGetter = (
    tenantId: string,
    commandId: string,
    query?: {
      /** @default false */
      retryNonFailed?: boolean;
      /** @pattern [^\s\\/]+ */
      crmRequestId?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/command/${commandId}/retry`, query);

  /**
   * @description Skip a command. CommandId in path is a skip target, commandId in query new commandId
   *
   * @tags Meetings CRM SecuredAPI
   * @name PostApiV1TenantTenantidCommandCommandidSkip
   * @request POST:/v1/tenant/{tenantId}/command/{commandId}/skip
   * @secure
   */
  postApiV1TenantTenantidCommandCommandidSkip = (
    tenantId: string,
    commandId: string,
    data: CommandIdDto,
    params: RequestParams = {},
  ) =>
    this.request<
      CommandAcceptedResponseDto,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/command/${commandId}/skip`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidCommandCommandidSkip */
  postApiV1TenantTenantidCommandCommandidSkipPathGetter = (tenantId: string, commandId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/command/${commandId}/skip`);
}
